import { Enums } from '@bode-canada/core';
import ServerlessApiService from '../ServerlessApiService';

const { NewListingSoldApiPathEnum, ServerlessApiPathEnum } = Enums;

export interface NewListingSoldDto {
  listingId: number;
  addressId: number;
  listPrice: number;
  price: number;
  daysOnMarket: number;
  commissionSavings: number;
  publishedAt: Date;
  closedAt: Date;
  status: Enums.ListingStatusEnum;
}

export interface NewListingLinkDto {
  listingId: number;
  addressId: number;
  price: number;
}

export default class SoldNewListingApiService {
  static BASE_URL = `${NewListingSoldApiPathEnum.NEW_LISTINGS_SOLD}/${ServerlessApiPathEnum.V1}`;

  static getSoldTransactionsByAddressId(addressId: number): Promise<NewListingSoldDto[]> {
    return ServerlessApiService.get(
      `${this.BASE_URL}`,
      { params: { addressId } },
    );
  }

  static getActiveByAddressId(addressId: number): Promise<NewListingLinkDto> {
    return ServerlessApiService.get(
      `${this.BASE_URL}/${NewListingSoldApiPathEnum.ACTIVE_LINK}`,
      { params: { addressId } },
    );
  }
}
